<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">
          <h3>Figyelem</h3>
        </v-card-title>

        <v-card-text>
          A következő műsorszám megtekintése 18 éven aluliak számára nem ajánlott
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            block
            fullwidth
            text
            @click="dialog = false"
          >
            Nem vagyok még 18 éves
          </v-btn>
          <br>

          <v-btn
            color="primary"
            block
            fullwidth
            text
            @click="agree()"
          >
            Elmúltam 18 éves
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
  export default {
    name: 'Confirm',
    data () {
      return {
        dialog: false,
        param: null
      }
    },
    methods: {
      open(param) {
        this.dialog = true
        this.param = param || null
      },
      agree() {
        this.$emit('agree', this.param)
        this.dialog = false
      }
    }
  }
</script>
<style>
  .v-card__actions {
    display: block !important;
  }
</style>
